import appReducer from './app';
import globalReducer from './global';
import adminReducer from './admin';
import emailCardReducer from './email-card';
import caseMultiTabsReducer from './case-multi-tabs';
import caseFieldReducer from './case-field';
import caseFormReducer from './case-form';
import caseViewReducer from './case-view';
import caseProcessReducer from './case-process';
import quillReducer from './quill';
import tagsReducer from './tags';
import ebaReducer from './event-base-automation';
import ebaGroupReducer from './event-base-automation-group';
import webFormConfigReducer from './web-form-config';

const rootReducer = {
  app: appReducer,
  global: globalReducer,
  admin: adminReducer,
  emailCard: emailCardReducer,
  caseMultiTabs: caseMultiTabsReducer,
  caseField: caseFieldReducer,
  caseForm: caseFormReducer,
  caseView: caseViewReducer,
  caseProcess: caseProcessReducer,
  quill: quillReducer,
  tags: tagsReducer,
  eba: ebaReducer,
  ebaGroup: ebaGroupReducer,
  webFormConfig: webFormConfigReducer,
};

export default rootReducer;
